// AUTOGENERATED
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dCountries from "../Restaumatic.Countries/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const ValidatePhoneNumberRequest = x => x;
const rPCMethodNameValidatePhon = {rpcMethodName: v => "ValidatePhoneNumberRequest"};
const newtypeValidatePhoneNumbe = {Coercible0: () => {}};
const hasFieldValidatePhoneNumb = dictHasField => dictHasField;
const eqValidatePhoneNumberRequ = {
  eq: x => y => (() => {
    if (x.country.tag === "PL") { return y.country.tag === "PL"; }
    if (x.country.tag === "GB") { return y.country.tag === "GB"; }
    if (x.country.tag === "RU") { return y.country.tag === "RU"; }
    if (x.country.tag === "RO") { return y.country.tag === "RO"; }
    if (x.country.tag === "CZ") { return y.country.tag === "CZ"; }
    if (x.country.tag === "HR") { return y.country.tag === "HR"; }
    if (x.country.tag === "SK") { return y.country.tag === "SK"; }
    if (x.country.tag === "DE") { return y.country.tag === "DE"; }
    if (x.country.tag === "NL") { return y.country.tag === "NL"; }
    if (x.country.tag === "ES") { return y.country.tag === "ES"; }
    if (x.country.tag === "BR") { return y.country.tag === "BR"; }
    if (x.country.tag === "IT") { return y.country.tag === "IT"; }
    return false;
  })() && x.phone === y.phone
};
const genericValidatePhoneNumberRequest = {to: x => x, from: x => x};
const showValidatePhoneNumberRequest = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["country", Restaumatic$dCountries.showCountry.show(v.country)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
            "phone",
            Data$dShow.showStringImpl(v.phone)
          ]))([]));
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "ValidatePhoneNumberRequest"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeValidatePhoneNumberRequest = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "country"})(Restaumatic$dCountries.unscrambleDecodeCountry)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "phone"
    })(Unscramble.decodeString1)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeValidatePhoneNumberRequest = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericValidatePhoneNumberRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "ValidatePhoneNumberRequest"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "phone"})({
      encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
    }))({reflectSymbol: () => "country"})({encodeWithOptions: v => Restaumatic$dCountries.encodeCountry.encode});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeValidatePhoneNumberRequest = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericValidatePhoneNumberRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ValidatePhoneNumberRequest"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "phone"
  })({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "country"})({
    decodeWithOptions: v => Restaumatic$dCountries.decodeCountry.decode
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  ValidatePhoneNumberRequest,
  decodeValidatePhoneNumberRequest,
  encodeValidatePhoneNumberRequest,
  eqValidatePhoneNumberRequ,
  genericValidatePhoneNumberRequest,
  hasFieldValidatePhoneNumb,
  newtypeValidatePhoneNumbe,
  rPCMethodNameValidatePhon,
  showValidatePhoneNumberRequest,
  unscrambleDecodeValidatePhoneNumberRequest
};
